import { BillLineItemV2Kind, BillRawV3, BillStatus } from '@types'

const billDetailV3WaitingPaymentWithDebit: BillRawV3 = {
  closing_date: '2022-10-05T00:00:00Z',
  deliquency_fine_rate: 31001,
  due_amount: 31002,
  due_date: '2022-10-01T00:00:00Z',
  effective_due_date: '2023-03-08T00:00:00Z',
  flags: {
    has_debit: true,
    is_empty: false,
    is_zero: false,
    show_amounts_header: true,
  },
  id: 'fatura-WAITING_PAYMENT',
  line_item_groups: [
    {
      line_items: [
        {
          amount_cents: 1002,
          id: 'line_item_id_02',
          kind: BillLineItemV2Kind.DebtPurchase,
          metadata: {
            activated_at: '2022-04-10T00:00:00Z',
            base_debt_id: 'base_debt_id-99',
            created_at: '2023-12-01T00:00:00Z',
            due_at: '2023-12-01T00:00:00Z',
            paid_amount_cents: 0,
            purchase_debt_id: 'purchase-debit-id-1',
            total_amount_cents: 1000,
          },
          payer_id: 'player_id_01',
          reference_date: '2023-12-01T00:00:00Z',
        },
      ],
      is_paid: false,
    },
  ],
  minimum_amount: 200,
  paid_amount: 31003,
  payable: false,
  spent_amount: 31004,
  status: BillStatus.WaitingPayment,
}

export default billDetailV3WaitingPaymentWithDebit
